import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GROUP_ITEMS } from "../messaging-tokens";
import { MessageInput, PurchaseFilterType, ReadLookup } from "../model/message-input.model";
import { Message } from "../model/message.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { GridFilter, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { form_control } from "projects/sepidz-web-framework/src/lib/models/form-control.model";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { MessageTemplate } from "../model/message-template.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";

interface InfoModel {
  RemainCredit: number;
}
@Component({
  selector: "ngx-group-message",
  templateUrl: "./group-message.component.html",
  styleUrls: ["./group-message.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupMessageComponent extends BaseFormComponent<Message> {
  currentMessageTemplate: MessageTemplate;
  currentData: PagingDataResult<any> = new PagingDataResult<any>();
  groupItems: NameValue[] = GROUP_ITEMS;
  purchaseFilterTypeList: ReadLookup[] = [];
  messageInput: MessageInput = <MessageInput>{};
  purchaseFilterType: PurchaseFilterType;
  currentPurchaseFilterTypeId: number;
  tryToSendSgain: boolean = false;
  selected: string = "";
  info: InfoModel;
  get PurchaseFilterTypeId() {
    return this.formGroup.controls["PurchaseFilterTypeId"].value;
  }
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, _tabsservice: TabularService, __id: FormContainerModel) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.apiName = "Message";
    this.areaName = "General";
    this.label = this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.SendingGroupMessage");
    //super.ngOnInit();
    this.purchaseFilterTypeList;
    let rl: ReadLookup = <ReadLookup>{};
    rl.Id = 1;
    rl.Title = this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.BuyerCustomers");
    this.purchaseFilterTypeList.push(rl);
    rl = <ReadLookup>{};
    rl.Id = 2;
    rl.Title = this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.CustomersWithoutPurchase");
    this.purchaseFilterTypeList.push(rl);
    this.setColumns();
    this.getContactInfo();
    this.setdefault();
  }
  async setColumns() {
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.CustomerName"),
      name: "CustomerDisplayName",
      order: 0,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "CustomerDisplayName",
      maxLength: 256,
      controlType: FormControlTypes.textbox,
      disabled: true,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.CustomerCode"),
      name: "Number",
      order: 1,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "Number",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.CustomerGroup"),
      name: "CustomerCategory",
      order: 2,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "CustomerCategory",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.MaxPurchase"),
      name: "MaximumPurchaseAmount",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "number",
      modelName: "MaximumPurchaseAmount",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.SumPurchase"),
      name: "TotalPurchaseAmount",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "number",
      modelName: "TotalPurchaseAmount",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.QtyPurchase"),
      name: "TotalPurchaseCount",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "number",
      modelName: "TotalPurchaseCount",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.SumPurchaseWithDate"),
      name: "PeriodPurchaseAmount",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "number",
      modelName: "PeriodPurchaseAmount",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.QtyPurchaseWithDate"),
      name: "PeriodPurchaseCount",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "number",
      modelName: "PeriodPurchaseCount",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.DateCreate"),
      name: "ShamsiCreationDateTime",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "ShamsiCreationDateTime",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.DatePurchase"),
      name: "ShamsiLastPurchaseDateTime",
      order: 3,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "text",
      modelName: "ShamsiLastPurchaseDateTime",
      controlType: FormControlTypes.textbox,
      maxLength: 20,
      minLength: 6,
      disabled: false,
    });
    this.orignalColumns = this.columns;
    this.loadData();
  }
  loadData() {
    let _model = this.messageInput;
    if (!_model) _model = <MessageInput>{};
    _model.CustomerIds = null;
    if (!_model.pageSize || _model.pageSize === 0) {
      _model.skip = 0;
      _model.pageSize = 10;
    }
    this.httpCommonService
      .create(this.apiName + "/ReceiverList", _model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x: PagingDataResult<any>) => {
          this.currentData = x;
          this.cd.markForCheck();
        },
        (error) => this.getFailedHelper(error)
      );
  }
  setdefault() {
    this.messageInput = <MessageInput>{};
    if (!this.messageInput.ExpirationTime) this.messageInput.ExpirationTime = "02:00:00";
    this.setFormGroup(this.messageInput);
    if (!this.accountService.authService.currentInformation().HasShortMessage) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.LicensedForSection")}`,
        this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.SoftwareLicense")
      );
      this.close();
    }
  }
  addControl() {
    this.setValue("GenderIds", this.messageInput.GenderIds);
    this.setValue("ZoneIds", this.messageInput.ZoneIds);
    this.setValue("CustomerCategoryIds", this.messageInput.CustomerCategoryIds);
    this.setValue("PurchaseFilterTypeId", this.messageInput.PurchaseFilterTypeId);
    this.setValue("FromPurchaseAmount", this.messageInput.FromPurchaseAmount);
    this.setValue("ToPurchaseAmount", this.messageInput.ToPurchaseAmount);
    this.setValue("FromTotalPurchaseAmount", this.messageInput.FromTotalPurchaseAmount);
    this.setValue("ToTotalPurchaseAmount", this.messageInput.ToTotalPurchaseAmount);
    this.setValue("FromPurchaseCount", this.messageInput.FromPurchaseCount);
    this.setValue("ToPurchaseCount", this.messageInput.ToPurchaseCount);
    this.setValue("MessageTypeId", this.model.MessageTypeId);
    this.setValue("Text", this.messageInput.Text);
    this.setValue("ExpirationTime", this.messageInput.ExpirationTime);
    this.setValue("PurchaseEndTime", this.messageInput.PurchaseEndTime);
    this.setValue("PurchaseStartTime", this.messageInput.PurchaseStartTime);
    this.setValue("RegistrationStartTime", this.messageInput.RegistrationStartTime);
    this.setValue("RegistrationEndTime", this.messageInput.RegistrationEndTime);
  }
  isValid() {
    return (
      (this.messageInput.Text !== undefined || this.model.MessageTypeId !== undefined) &&
      this.currentData !== undefined &&
      this.currentData.TotalPage > 0 &&
      this.info &&
      this.info.RemainCredit &&
      this.info.RemainCredit > 0
    );
  }
  onChanged($event) {
    if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("CustomerCategory/ReadLookUp")) {
      this.messageInput.PurchaseFilterTypeCode = $event.data.Code;
      this.messageInput.PurchaseFilterTypeTitle = $event.data.Title;
    }
  }
  change(event) {
    if (event && event.Text) {
      this.messageInput.Text = event.Text;
    }
  }
  toggleDirection(event) {
    this.tryToSendSgain = event;
  }
  getContactInfo() {
    this.httpCommonService
      .get(this.apiName + "/GetAccountInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (info: InfoModel) => (this.info = info),
        (error) => this.getFailedHelper(error)
      );
  }
  submitForm() {
    if (this.isValid()) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.AboutSendingGroupSMS")}`,
        this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.ConfirmAndSend"),
        DialogType.confirm,
        () => this.SendMessage()
      );
      this.sts.showToast(
        "info",
        this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.ConfirmAndSend"),
        this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.SendingGroupSMS")
      );
    }
  }
  SendMessage() {
    if (this.isValid()) {
      let _model = this.messageInput;
      if (!this.messageInput.PurchaseFilterTypeId) {
        _model = <MessageInput>{};
        _model.Text = this.messageInput.Text;
        _model.CustomerIds = this.messageInput.CustomerIds;
      }
      if (_model.CustomerIds && _model.CustomerIds.length < 1) _model.CustomerIds = null;
      _model.ExpirationTime = this.messageInput.ExpirationTime;

      this.httpCommonService
        .create(this.apiName + "/SendGroupMessage", _model)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.sts.showToast(
              "success",
              this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.ConfirmAndSend"),
              this.translate("ClientApp.FrontOffice.Messaging.GroupMessage.OperationWasSuccessful")
            );
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  onRowsSelected(event) {
    if (event) {
      this.messageInput.CustomerIds = [];
      event.forEach((element) => {
        this.messageInput.CustomerIds.push(element.Id);
      });
    }
  }
  ApplayFilter() {
    this.messageInput.skip = 0;
    this.messageInput.pageSize = 10;
    this.messageInput.GenderIds = this.formGroup.value.GenderIds;
    this.messageInput.ZoneIds = this.formGroup.value.ZoneIds;
    this.messageInput.PurchaseStartTime = this.formGroup.value.PurchaseStartTime;
    this.messageInput.PurchaseEndTime = this.formGroup.value.PurchaseEndTime;
    this.messageInput.CustomerCategoryIds = this.formGroup.value.CustomerCategoryIds;
    this.messageInput.PurchaseFilterTypeId = this.formGroup.value.PurchaseFilterTypeId;
    this.messageInput.FromPurchaseAmount = this.formGroup.value.FromPurchaseAmount;
    this.messageInput.ToPurchaseAmount = this.formGroup.value.ToPurchaseAmount;
    this.messageInput.FromTotalPurchaseAmount = this.formGroup.value.FromTotalPurchaseAmount;
    this.messageInput.ToTotalPurchaseAmount = this.formGroup.value.ToTotalPurchaseAmount;
    this.messageInput.FromPurchaseCount = this.formGroup.value.FromPurchaseCount;
    this.messageInput.ToPurchaseCount = this.formGroup.value.ToPurchaseCount;
    this.model.MessageTypeId = this.formGroup.value.MessageTypeId;
    this.messageInput.Text = this.formGroup.value.Text;
    this.messageInput.ExpirationTime = this.formGroup.value.ExpirationTime;
    this.messageInput.RegistrationStartTime = this.formGroup.value.RegistrationStartTime;
    this.messageInput.RegistrationEndTime = this.formGroup.value.RegistrationEndTime;
    this.loadData();
  }
  onPageChanged(event: GridFilter[]) {
    this.messageInput.skip = !event || !event.length ? 0 : event[0].Skip;
    this.messageInput.pageSize = !event || !event.length ? 10 : event[0].Take;
    this.loadData();
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
    this.cd.markForCheck();
  }
}
